var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendChatMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4103 21.2514L8.55109 30.0335C8.10248 30.2129 7.67623 30.175 7.27234 29.9198C6.86845 29.6642 6.6665 29.295 6.6665 28.8123V11.1839C6.6665 10.7011 6.86845 10.332 7.27234 10.0764C7.67623 9.82114 8.10248 9.78322 8.55109 9.96267L29.4103 18.7448C29.955 18.9864 30.2273 19.4042 30.2273 19.9981C30.2273 20.592 29.955 21.0098 29.4103 21.2514ZM8.33317 28.3314L28.0832 19.9981L8.33317 11.6648V18.1389L16.4103 19.9981L8.33317 21.8573V28.3314Z",
    fill: "#0E88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChatMessageIcon);
export default __webpack_public_path__ + "static/media/send-chat-message-icon.90215ac554bd2f4c534292fecc116060.svg";
export { ForwardRef as ReactComponent };